import { useCallback } from 'react';
import { useDocumentAPI } from './useDocumentAPI';
import type { PilotAssessmentExportData } from '../types/pilot-assessment-export';

export interface UsePDFExportPilotAssessmentOptions {
  onExportStart?: () => void;
  onExportSuccess?: (blob: Blob, filename: string) => void;
  onExportError?: (error: Error) => void;
}

export interface UsePDFExportPilotAssessmentReturn {
  exportPilotAssessmentToPDF: (data: PilotAssessmentExportData) => Promise<Blob>;
  isExporting: boolean;
  error: Error | null;
}

export function usePDFExportPilotAssessment(
  options: UsePDFExportPilotAssessmentOptions = {},
): UsePDFExportPilotAssessmentReturn {
  const { generateDocument, isExporting, error } = useDocumentAPI(options);

  const exportPilotAssessmentToPDF = useCallback(
    async (data: PilotAssessmentExportData): Promise<Blob> => {
      const roleLabel =
        data.metadata?.pilotRole === 'captain' ? 'Captain'
        : data.metadata?.pilotRole === 'captain_2' ? 'Captain_2'
        : data.metadata?.pilotRole === 'first_officer_2' ? 'First_Officer_2'
        : 'First_Officer';
      const defaultFilename = `WingMentor_${roleLabel}_Assessment_${data.partA.sessionDate.replace(/\//g, '-')}_${data.partA.trainee.name.replace(/\s+/g, '_')}.pdf`;
      return generateDocument('pilot-assessment', 'pdf', data as unknown as Record<string, unknown>, defaultFilename);
    },
    [generateDocument],
  );

  return { exportPilotAssessmentToPDF, isExporting, error };
}
